import API from './api';

/**
 * Provider credits monitor (platform superadmin only).
 *
 * Thin wrappers, no try/catch: callers get the real axios error. Kept out of
 * PlatformAdminService on purpose — the console's tests mock that module with
 * a fixed list of functions.
 *
 * The GET only reads stored check results and never contacts a provider; the
 * refresh POST runs live read-only balance checks and returns the same payload.
 */

const BASE = '/auth/platform_admin/providers/credits';

export const getProviderCredits = ({ days = 30, signal } = {}) =>
  API.get(`${BASE}/`, { params: { days }, signal }).then((r) => r.data);

/**
 * `providers` is an optional list of slot keys; omit it to refresh every
 * configured slot. `days` is the history window the answer is computed for,
 * as on the GET (the server defaults to 30), so the page can show the answer
 * as is instead of re-reading its own window.
 */
export const refreshProviderCredits = (providers, { days } = {}) =>
  API.post(`${BASE}/refresh/`, providers ? { providers } : {}, { params: { days } }).then((r) => r.data);
